<template lang="pug">
.main-sidebar.sidebar-style-2
  aside#sidebar-wrapper
    .sidebar-brand.my-2
      .nav-link.dropdown-toggle.nav-link-lg.nav-link-user.text-white(data-toggle='dropdown')
        img.rounded-circle.profile.mr-1(alt='image' :src='"/assets/img/country/" + getCurrencyCode + ".png"')
        .d-inline-block [{{ serverName }}] {{ $store.getters.displayName }}
      .dropdown-menu.ml-5
        router-link.dropdown-item.has-icon(to='/system/setting' :title="$t('ui.password')")
          i.far.fa-user
          | {{ $t("ui.password") }}
        //- router-link.dropdown-item.has-icon(to='/system/setting' :title="$t('ui.settings')")
        //-   i.fas.fa-lock
        //-   | {{ $t("ui.settings") }}
        .dropdown-divider
        router-link.dropdown-item.has-icon.text-danger(to="/logout" :title="$t('ui.logout')")
          i.fas.fa-sign-out-alt
          | {{ $t("ui.logout") }}
    .sidebar-brand.sidebar-brand-sm.my-2
      .nav-link.nav-link-lg.nav-link-user
        router-link(to='/system/dashboard')
          img.rounded-circle.profile.mr-1(alt='image' :src='"/assets/img/country/" + getCurrencyCode + ".png"')
    sidebarnav(:navItems="isOperator ? navItemsOpr : navItems")
</template>

<script>
import config from "@/config";
import sidebarnav from "@/components/layout/sidebarnav.vue";
import errorTags from "@/errorTags";

export default {
  components: {
    sidebarnav,
    errorTags
  },
  data() {
    return {
      timerId: null,
      refreshTime: 60,
      subDetail: null,
      affTotalRow: 0,
      tixTotalRow: 0,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      fcTotalRow: 0,
      refreshTimeFc: 5,
      timerIdFc: null
    };
  },
  computed: {
    serverName() {
      return config.serverName;
    },
    theme() {
      return config.brandName.toLowerCase();
    },
    navItems() {
      return [
        {
          name: this.$t("ui.dashboard"),
          icon: "fas fa-fire",
          url: "/system/dashboard",
          // tab: "dashboard",
          // pages: [config.accessRoles.dashboard]
        },
        {
          name: this.$t("ui.website"),
          icon: "fas fa-globe",
          // pages: [config.accessRoles.domainlist, config.accessRoles.domainapplication, config.accessRoles.domainop],
          // tab: "",
          pages: [config.accessRoles.website],
          children: [
            {
              name: this.$tc("ui.domain_list", 1),
              url: "/domain/domainList",
              icon: "fa fa-link",
              // tab: "domain_list",
              pages: [config.accessRoles.domainlist, config.accessRoles.domainop],
            },
            {
              name: this.$t("ui.domain_available"),
              url: "/domain/domainAvailable",
              icon: "fa fa-link",
              // tab: "domain_available",
              pages: [config.accessRoles.domainavailable],
            },
            {
              name: this.$t("ui.domain_application"),
              url: "/domain/domainApplication",
              icon: "fa fa-link",
              // tab: "domain_application",
              pages: [config.accessRoles.domainapplication],
            },
            {
              name: this.$t("ui.new_website"),
              url: "/site/newwebsite",
              icon: "fas fa-globe",
              pages: [config.accessRoles.newwebsite],
            },
            {
              name: this.$t("ui.operator_information"),
              url: "/site/operatorinformation",
              icon: "fa fa-users",
              pages: [config.accessRoles.operatorinformation],
            },
            {
              name: this.$t("ui.site_customization"),
              url: "/site/sitelist",
              icon: "fas fa-newspaper",
              // tab: "site_customization",
              pages: [config.accessRoles.sitelist],
            },
            {
              name: this.$t("ui.site_customization"),
              url: "/site/siteinfo",
              icon: "fas fa-newspaper",
              // tab: "site_customization",
              pages: [config.accessRoles.siteinfo],
            },
            {
              name: this.$t("ui.cms"),
              url: "/account/operator?targetTab=cms",
              icon: "fas fa-window-maximize",
              // tab: "cms",
              pages: [config.accessRoles.cms, config.accessRoles.aiassistant],
            }
          ]
        },
        {
          name: this.$t("ui.account"),
          icon: "fas fa-users",
          pages: [config.accessRoles.account],
          children: [
            {
              name: this.$t("ui.members"),
              url: "/account/operator?targetTab=memberlist",
              icon: "fa fa-users",
              // tab: "member",
              pages: [config.accessRoles.memberlist],
            },
            {
              name: this.$t("ui.member_label"),
              url: "/account/operator?targetTab=memberlabel",
              icon: "fas fa-user-tag",
              // tab: "member_label",
              pages: [config.accessRoles.memberlabel],
            },
            {
              name: this.$t("ui.sub_account"),
              url: "/account/subAccount",
              icon: "fa fa-user-plus",
              // tab: "sub_account",
              pages: [config.accessRoles.subaccount]
            },
            // {
            //   name: this.$t("ui.social_account"),
            //   url: "/account/operator?targetTab=socialaccount",
            //   icon: "far fa-address-card",
            //   // tab: "social_account",
            //   pages: [config.accessRoles.socialaccount],
            // },
            {
              name: this.$t("ui.ip_whitelist"),
              url: "/account/ipWhitelist",
              icon: "fa fa-map-marker",
              // tab: "ip_whitelist",
              pages: [config.accessRoles.ipwhitelist]
            },
            {
              name: this.$t("ui.vip"),
              url: "/account/operator?targetTab=vip",
              icon: "fas fa-crown",
              // tab: "vip",
              pages: [config.accessRoles.vip],
            }
          ]
        },
        {
          name: this.$t("ui.operator"),
          icon: "fas fa-user-secret",
          pages: [config.accessRoles.operator, config.accessRoles.operatorsummary],
          children: [
            {
              name: this.$tc("ui.operators", 1),
              url: "/account/operator",
              icon: "fas fa-user-secret",
              // tab: "operator",
              pages: [config.accessRoles.operator],
            },
            {
              name: this.$t("ui.promotion"),
              url: "/account/operator?targetTab=promotion",
              icon: "fas fa-gift",
              pages: [config.accessRoles.promotion],
            },
            {
              name: this.$t("ui.campaign"),
              url: "/account/operator?targetTab=campaign",
              icon: "fas fa-calendar-check",
              pages: [config.accessRoles.campaign],
            },
            {
              name: this.$t("ui.rescue_fund"),
              url: "/account/operator?targetTab=rescuefund",
              icon: "fas fa-life-ring",
              pages: [config.accessRoles.rescuefund],
            },
            {
              name: this.$t("ui.turnover_tier"),
              url: "/account/operator?targetTab=turnovertier",
              icon: "fas fa-layer-group",
              pages: [config.accessRoles.turnovertier],
            },
            {
              name: this.$t("ui.mbsetting"),
              url: "/account/operator?targetTab=operatorsetting",
              icon: "fas fa-cog",
              pages: [config.accessRoles.operatorsetting],
            },
            {
              name: this.$t("ui.operator_summary"),
              url: "/account/operatorsummary",
              icon: "fa fa-users",
              pages: [config.accessRoles.operatorsummary],
            },
          ]
        },
        {
          name: this.$t("ui.ticket"),
          icon: "fas fa-list-alt",
          pages: [config.accessRoles.ticketlist, config.accessRoles.pendingticket, config.accessRoles.ticketlistautowithdrawal, config.accessRoles.ticketlistreviewaudit, config.accessRoles.ticketlistop],
          children: [
            {
              name: this.$t("ui.ticket_list_member"),
              url: "/ticketoperator/ticketListOp",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlistop],
            },
            {
              name: this.$t("ui.ticket_list"),
              url: "/ticket/ticketList",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlist],
            },
            {
              name: this.$t("ui.pending_review_funds"),
              url: "/ticket/pendingTicket",
              icon: "fas fa-list-alt",
              // badge: this.supersedeBadge,
              pages: [config.accessRoles.pendingticket],
            },
            {
              name: this.$t("ui.daifu_list_auto_withdrawal"),
              url: "/ticket/ticketListAutoWithdrawal",
              icon: "fas fa-list-alt",
              // badge: this.supersedeBadge,
              pages: [config.accessRoles.ticketlistautowithdrawal],
            },
            {
              name: this.$t("ui.audit_list"),
              url: "/ticket/ticketListReviewAudit",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlistreviewaudit],
            },
          ]
        },
        {
          name: this.$t("ui.ticketvoucher"),
          icon: "fas fa-list-alt",
          pages: [config.accessRoles.ticketvoucherlist, config.accessRoles.pendingticketvoucher, config.accessRoles.ticketlistopvoucher],
          children: [
            {
              name: this.$t("ui.ticket_voucher_list_member"),
              url: "/ticketvoucher/ticketListOpVoucher",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlistopvoucher],
            },
            {
              name: this.$t("ui.ticket_voucher_list"),
              url: "/ticketvoucher/ticketVoucherList",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketvoucherlist],
            },
            {
              name: this.$t("ui.pending_review_funds_voucher"),
              url: "/ticketvoucher/pendingTicketVoucher",
              icon: "fas fa-list-alt",
              // badge: this.supersedeBadge,
              pages: [config.accessRoles.pendingticketvoucher],
            }
          ]
        },
        {
          name: this.$t("ui.global_setting"),
          icon: "fas fa-cog",
          pages: [config.accessRoles.providermaintenance, config.accessRoles.profilesetting, config.accessRoles.socialplatformlookup,
                  config.accessRoles.exchangerate, config.accessRoles.providerptglobal, config.accessRoles.gamifyglobal, config.accessRoles.linkage],
          children: [
            {
              name: this.$t("ui.provider_maintenance"),
              url: "/globalsetting/providermaintenance",
              icon: "fa fa-cog",
              pages: [config.accessRoles.providermaintenance],
            },
            {
              name: this.$t("ui.profile_setting"),
              url: "/globalsetting/profilesetting",
              icon: "fa fa-cog",
              pages: [config.accessRoles.profilesetting],
            },
            {
              name: this.$t("ui.social_platform"),
              url: "/globalsetting/socialplatformlookup",
              icon: "fa fa-cog",
              pages: [config.accessRoles.socialplatformlookup],
            },
            {
              name: this.$t("ui.exchange_rate"),
              url: "/globalsetting/exchangerate",
              icon: "fa fa-cog",
              pages: [config.accessRoles.exchangerate],
            },
            {
              name: this.$t("ui.payment_option"),
              url: "/globalsetting/paymentOption",
              icon: "fa fa-cog",
              pages: [config.accessRoles.paymentoption],
            },
            {
              name: this.$t("ui.provider_pt"),
              url: "/globalsetting/providerPtGlobal",
              icon: "fa fa-cog",
              pages: [config.accessRoles.providerptglobal],
            },
            {
              name: this.$t("ui.reward"),
              url: "/globalsetting/gamifyGlobal",
              icon: "fa fa-cog",
              pages: [config.accessRoles.gamifyglobal],
            },
            {
              name: this.$t("ui.mission"),
              url: "/globalsetting/globalmission",
              icon: "fa fa-cog",
              pages: [config.accessRoles.globalmission],
            },
            // {
            //   name: this.$t("ui.linkage"),
            //   url: "/globalsetting/linkage",
            //   icon: "fa fa-cog",
            //   pages: [config.accessRoles.linkage],
            // }
          ]
        },
        {
          name: this.$t("ui.report"),
          icon: "fas fa-chart-line",
          pages: [config.accessRoles.dailysummaryoperator, config.accessRoles.dailyledger, config.accessRoles.providerwinlosecompany,
                  config.accessRoles.dailywinlosegame, config.accessRoles.providerwinloseoperator, config.accessRoles.providerwinloseoperatorpt,
                  config.accessRoles.onetimedepositor, config.accessRoles.currentmonthnondepositor, config.accessRoles.currentmonthnologin,
                  config.accessRoles.depositedmember, config.accessRoles.registeredmember, config.accessRoles.firstdeposit,
                  config.accessRoles.promotionsignupunused, config.accessRoles.promotionsignupongoing, config.accessRoles.promotionsignupwinlose, config.accessRoles.promotionsummary, config.accessRoles.promotionwithdrawalsummary, config.accessRoles.rebatesummary,
                  config.accessRoles.rebatemember, config.accessRoles.rescuefundsummary, config.accessRoles.dailysummarysms, config.accessRoles.themepurchased,
                  config.accessRoles.dailysummarycompany, config.accessRoles.totalplayedminigame, config.accessRoles.dailypnloperator, config.accessRoles.totalminigamecoinused,
                  config.accessRoles.totalminigamereward, config.accessRoles.voucherredeemed
          ],
          children: [
            {
              name: this.$t("ui.daily_winlose_game"),
              url: "/report/dailyWinLoseGame",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailywinlosegame]
            },
            {
              name: this.$t("ui.provider_winlose_company"),
              url: "/report/providerWinLoseCompany",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.providerwinlosecompany]
            },
            {
              name: this.$t("ui.provider_winlose_operator"),
              url: "/report/providerWinLoseOperator",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.providerwinloseoperator]
            },
            {
              name: this.$t("ui.provider_winlose_operator_pt"),
              url: "/report/providerWinLoseOperatorPt",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.providerwinloseoperatorpt]
            },
            {
              name: this.$t("ui.daily_pnl_operator"),
              url: "/report/dailyPnlOperator",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailypnloperator]
            },
            {
              name: this.$t("ui.daily_summary_company"),
              url: "/report/dailySummaryCompany",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailysummarycompany]
            },
            {
              name: this.$t("ui.daily_summary_operator"),
              url: "/report/dailySummaryOperator",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailysummaryoperator]
            },
            {
              name: this.$t("ui.daily_summary_sms"),
              url: "/report/dailySummarySMS",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailysummarysms]
            },
            {
              name: this.$t("ui.daily_ledger"),
              url: "/report/dailyLedger",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailyledger]
            },
            {
              name: this.$t("ui.one_time_depositor"),
              url: "/report/oneTimeDepositor",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.onetimedepositor]
            },
            {
              name: this.$t("ui.current_month_non_depositor"),
              url: "/report/currentMonthNonDepositor",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.currentmonthnondepositor]
            },
            {
              name: this.$t("ui.current_month_no_login"),
              url: "/report/currentMonthNoLogin",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.currentmonthnologin]
            },
            {
              name: this.$t("ui.deposited_member"),
              url: "/report/depositedMember",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.depositedmember]
            },
            {
              name: this.$t("ui.registered_member"),
              url: "/report/registeredMember",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.registeredmember]
            },
            {
              name: this.$t("ui.first_deposit"),
              url: "/report/firstDeposit",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.firstdeposit]
            },
            {
              name: this.$t("ui.promotion_signup_unused"),
              url: "/report/promotionSignupUnused",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionsignupunused]
            },
            {
              name: this.$t("ui.promotion_signup_ongoing"),
              url: "/report/promotionSignupOngoing",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionsignupongoing]
            },
            {
              name: this.$t("ui.promotion_signup_winlose"),
              url: "/report/promotionSignUpWinlose",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionsignupwinlose]
            },
            {
              name: this.$t("ui.promotion_summary"),
              url: "/report/promotionSummary",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionsummary]
            },
            {
              name: this.$t("ui.promotion_withdrawal_summary"),
              url: "/report/promotionWithdrawalSummary",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionwithdrawalsummary]
            },
            {
              name: this.$t("ui.rebate_summary"),
              url: "/report/rebateSummary",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.rebatesummary]
            },
            {
              name: this.$t("ui.rebate_member"),
              url: "/report/rebateMember",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.rebatemember]
            },
            {
              name: this.$t("ui.rescue_fund_summary"),
              url: "/report/rescueFundSummary",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.rescuefundsummary]
            },
            {
              name: this.$t("ui.theme_purchased"),
              url: "/report/themepurchased",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.themepurchased],
            },
            {
              name: this.$t("ui.total_played_mini_game"),
              url: "/report/totalPlayedMiniGame",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.totalplayedminigame],
            },
            {
              name: this.$t("ui.total_mini_game_token_used"),
              url: "/report/totalMiniGameCoinUsed",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.totalminigamecoinused],
            },
            {
              name: this.$t("ui.total_mini_game_reward"),
              url: "/report/totalMiniGameReward",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.totalminigamereward],
            },
            {
              name: this.$t("ui.voucher_redeemed"),
              url: "/report/voucherRedeemed",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.voucherredeemed],
            }
          ]
        },
        {
          name: this.$t("ui.affiliate_management"),
          icon: "fas fa-user-tie",
          pages: [config.accessRoles.affiliatelist, config.accessRoles.approveaffiliate, config.accessRoles.ticketlistaffiliate, config.accessRoles.pendingticketaffiliate, config.accessRoles.adjustmentlogaffiliate],
          badge: this.totalBadge,
          children: [
            {
              name: this.$t("ui.affiliate_list"),
              url: "/affiliate/affiliateList",
              icon: "fas fa-user-tie",
              tab: "affiliate_list",
              pages: [config.accessRoles.affiliatelist],
            },
            {
              name: this.$t("ui.pending_application"),
              url: "/affiliate/approveAffiliate",
              icon: "fas fa-check-square",
              badge: this.affBadge,
              tab: "pending_application",
              pages: [config.accessRoles.approveaffiliate],
            },
            {
              name: this.$t("ui.withdrawal_list"),
              url: "/affiliate/ticketListAffiliate",
              icon: "fas fa-list-alt",
              tab: "withdrawal_list",
              pages: [config.accessRoles.ticketlistaffiliate],
            },
            {
              name: this.$t("ui.pending_review_withdrawal"),
              url: "/affiliate/pendingTicketAffiliate",
              icon: "fas fa-list-alt",
              // badge: this.tixBadge,
              pages: [config.accessRoles.pendingticketaffiliate],
            },
            {
              name: this.$t("ui.adjustment_log_affiliate"),
              url: "/affiliate/adjustmentLogAffiliate",
              icon: "fa fa-file",
              pages: [config.accessRoles.adjustmentlogaffiliate],
            },
            {
              name: this.$t("ui.audit_withdrawal"),
              url: "/affiliate/ticketListReviewAuditAffiliate",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlistreviewauditaffiliate],
            },
          ]
        },
        {
          name: this.$t("ui.free_credit_provider"),
          icon: "fas fa-user-alt",
          badge: this.totalFcBadge,
          pages: [config.accessRoles.ticketlistaffiliatefree, config.accessRoles.pendingticketaffiliatefree, config.accessRoles.ticketlistreviewauditaffiliatefree, 
                  config.accessRoles.ticketprocessedfree, config.accessRoles.adjustfreebalancelog],
          children: [
            {
              name: this.$t("ui.withdrawal_list"),
              url: "/freecreditprovider/ticketListAffiliateFree",
              icon: "fas fa-list-alt",
              tab: "withdrawal_list",
              pages: [config.accessRoles.ticketlistaffiliatefree],
            },
            {
              name: this.$t("ui.pending_review_withdrawal"),
              url: "/freecreditprovider/pendingTicketAffiliateFree",
              icon: "fas fa-list-alt",
              display_notif: this.displayFcNotif,
              // badge: this.tixBadge,
              pages: [config.accessRoles.pendingticketaffiliatefree],
            },
            {
              name: this.$t("ui.audit_withdrawal"),
              url: "/freecreditprovider/ticketListReviewAuditAffiliateFree",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlistreviewauditaffiliatefree],
            },
            {
              name: this.$t("ui.adjust_free_balance_log"),
              url: "/log/adjustFreeBalanceLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.adjustfreebalancelog],
            },
            {
              name: this.$t("ui.ticket_list_processed"),
              url: "/freecreditprovider/ticketProcessedFree",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketprocessedfree],
            },
          ]
        },
        {
          name: this.$t("ui.log"),
          icon: "fas fa-search",
          pages: [config.accessRoles.gamenameexlog, config.accessRoles.adjustmentlog, config.accessRoles.bonuslog, config.accessRoles.memberloginlog,
                  config.accessRoles.resultchangeslog, config.accessRoles.viplog, config.accessRoles.membertokenlog,
                  config.accessRoles.memberlog, config.accessRoles.membersosclicklog, config.accessRoles.memberwalletvoucherlog,
                  config.accessRoles.freespinlog, config.accessRoles.membervoucherredeemedlog],
          children: [
            {
              name: this.$t("ui.game_name_exclude_log"),
              url: "/log/gamenameexlog",
              icon: "fa fa-search",
              pages: [config.accessRoles.gamenameexlog],
            },
            {
              name: this.$t("ui.adjustment_log"),
              url: "/log/adjustmentLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.adjustmentlog],
            },
            {
              name: this.$t("ui.bonus_log"),
              url: "/log/bonusLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.bonuslog],
            },
            {
              name: this.$t("ui.login_log"),
              url: "/log/memberLoginLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.memberloginlog],
            },
            {
              name: this.$t("ui.result_changes_log"),
              url: "/log/resultChangesLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.resultchangeslog],
            },
            {
              name: this.$t("ui.vip_log"),
              url: "/log/vipLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.viplog],
            },
            {
              name: this.$t("ui.token_log"),
              url: "/log/membertokenLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.membertokenlog],
            },
            {
              name: this.$t("ui.member_log"),
              url: "/log/memberLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.memberlog],
            },
            {
              name: this.$t("ui.member_sos_click_log"),
              url: "/log/memberSosClickLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.membersosclicklog],
            },
            {
              name: this.$t("ui.member_wallet_voucher_log"),
              url: "/log/memberWalletVoucherLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.memberwalletvoucherlog],
            },
            {
              name: this.$t("ui.member_voucher_redeemed_log"),
              url: "/log/memberVoucherRedeemedLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.membervoucherredeemedlog],
            },
            {
              name: this.$t("ui.freespin_log"),
              url: "/log/freeSpinLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.freespinlog],
            },
          ]
        },
        {
          name: this.$t("ui.content_setup"),
          icon: "fas fa-list-ul",
          pages: [config.accessRoles.package, config.accessRoles.bodefaultdomain, config.accessRoles.language, config.accessRoles.themeprovider,
                  config.accessRoles.themecontent, config.accessRoles.themecontentgroup, config.accessRoles.themecontentposition, config.accessRoles.theme,
                  config.accessRoles.defaulttemplate, config.accessRoles.minigame],
          children: [
            {
              name: this.$t("ui.bo_default_domain"),
              url: "/content/bodefaultdomain",
              icon: "fas fa-globe-americas",
              pages: [config.accessRoles.bodefaultdomain],
            },
            // {
            //   name: this.$t("ui.package"),
            //   url: "/content/package",
            //   icon: "fas fa-gift",
            //   pages: [config.accessRoles.package],
            // },
            {
              name: this.$t("ui.language"),
              url: "/content/language",
              icon: "fas fa-globe",
              pages: [config.accessRoles.language],
            },
            {
              name: this.$t("ui.theme_provider"),
              url: "/content/themeprovider",
              icon: "fas fa-layer-group",
              pages: [config.accessRoles.themeprovider],
            },
            {
              name: this.$t("ui.theme_content"),
              url: "/content/themecontent",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.themecontent],
            },
            {
              name: this.$t("ui.theme_content_group"),
              url: "/content/themecontentgroup",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.themecontentgroup],
            },
            {
              name: this.$t("ui.theme_content_position"),
              url: "/content/themecontentposition",
              icon: "fas fa-book",
              pages: [config.accessRoles.themecontentposition],
            },
            {
              name: this.$t("ui.theme"),
              url: "/content/theme",
              icon: "fas fa-newspaper",
              pages: [config.accessRoles.theme],
            },
            {
              name: this.$t("ui.mini_game_template"),
              url: "/content/defaulttemplate",
              icon: "fas fa-clipboard-list",
              pages: [config.accessRoles.defaulttemplate],
            },
            {
              name: this.$t("ui.mini_game"),
              url: "/content/minigame",
              icon: "fas fa-gamepad",
              pages: [config.accessRoles.minigame],
            }
          ]
        },
      ];
    },
    navItemsOpr() {
      const cpiMenu = {
        name: this.$t("ui.cpi"),
        icon: "fas fa-address-book",
        pages: [config.accessRoles.cpi],
        children: [
          {
            name: this.$t("ui.member_list"),
            url: "/cpi/cpi",
            icon: "fas fa-address-card",
            pages: [config.accessRoles.cpi],
          },
          // {
          //   name: this.$t("ui.custom_list"),
          //   url: "/cpi/cpicustomlist",
          //   icon: "fas fa-address-book",
          //   pages: [config.accessRoles.cpi],
          // },
          // {
          //   name: this.$t("ui.phone_list"),
          //   url: "/cpi/cpioperatorphone",
          //   icon: "fas fa-phone",
          //   pages: [config.accessRoles.cpi],
          // },
        ],
      };

      if(!['MYR'].includes(this.getCurrencyCode)) {
        cpiMenu.children.push(
          {
            name: this.$t("ui.custom_list"),
            url: "/cpi/cpicustomlist",
            icon: "fas fa-address-book",
            pages: [config.accessRoles.cpi],
          },
          {
            name: this.$t("ui.phone_list"),
            url: "/cpi/cpioperatorphone",
            icon: "fas fa-phone",
            pages: [config.accessRoles.cpi],
          }
        )
      }

      return [
        {
          name: this.$t("ui.dashboard"),
          icon: "fas fa-fire",
          url: "/system/dashboard",
        },
        {
          name: this.$t("ui.website"),
          icon: "fas fa-globe",
          pages: [config.accessRoles.website],
          children: [
            {
              name: this.$tc("ui.domain_list", 1),
              url: "/domain/domainList",
              icon: "fa fa-link",
              pages: [config.accessRoles.domainlist, config.accessRoles.domainop],
            },
            {
              name: this.$t("ui.domain_available"),
              url: "/domain/domainAvailable",
              icon: "fa fa-link",
              pages: [config.accessRoles.domainavailable],
            },
            {
              name: this.$t("ui.domain_application"),
              url: "/domain/domainApplication",
              icon: "fa fa-link",
              pages: [config.accessRoles.domainapplication],
            },
            {
              name: this.$t("ui.site_customization"),
              url: "/site/sitelist",
              icon: "fas fa-newspaper",
              pages: [config.accessRoles.sitelist],
            },
            {
              name: this.$t("ui.site_customization"),
              url: "/site/siteinfo",
              icon: "fas fa-newspaper",
              pages: [config.accessRoles.siteinfo],
            },
            {
              name: this.$t("ui.cms"),
              url: "/account/operator?targetTab=cms",
              icon: "fas fa-window-maximize",
              pages: [config.accessRoles.cms, config.accessRoles.aiassistant],
            }
          ]
        },
        {
          name: this.$t("ui.account"),
          icon: "fas fa-users",
          pages: [config.accessRoles.account],
          children: [
            {
              name: this.$t("ui.sub_account"),
              url: "/account/subAccount",
              icon: "fa fa-user-plus",
              pages: [config.accessRoles.subaccount]
            },
            {
              name: this.$t("ui.ip_whitelist"),
              url: "/account/ipWhitelist",
              icon: "fa fa-map-marker",
              pages: [config.accessRoles.ipwhitelist]
            }
          ]
        },
        {
          name: this.$t("ui.operation_management"),
          icon: "fas fa-user-secret",
          pages: [config.accessRoles.ads, config.accessRoles.operatorsetting, config.accessRoles.turnovertier, config.accessRoles.paymentoption, config.accessRoles.bank],
          children: [
            {
              name: this.$t("ui.advertisement"),
              url: "/account/operator?targetTab=ads",
              icon: "fas fa-ad",
              pages: [config.accessRoles.ads],
            },
            {
              name: this.$t("ui.mbsetting"),
              url: "/account/operator?targetTab=operatorsetting",
              icon: "fas fa-cog",
              pages: [config.accessRoles.operatorsetting],
            },
            {
              name: this.$t("ui.turnover_tier"),
              url: "/account/operator?targetTab=turnovertier",
              icon: "fas fa-layer-group",
              pages: [config.accessRoles.turnovertier],
            },
            {
              name: this.$t("ui.payment_option"),
              url: "/account/operator?targetTab=paymentoption",
              icon: "fas fa-cog",
              pages: [config.accessRoles.paymentoption],
            },
            {
              name: this.$t("ui.bank"),
              url: "/account/operator?targetTab=bank",
              icon: "fas fa-landmark",
              pages: [config.accessRoles.bank, config.accessRoles.bankstatement, config.accessRoles.bankstatementdaily],
            },
          ]
        },
        {
          name: this.$t("ui.game_management"),
          icon: "fas fa-gamepad",
          pages: [config.accessRoles.provideroperator, config.accessRoles.gamenameexclude, config.accessRoles.gamifyoperator],
          children: [
            {
              name: this.$t("ui.game_provider_management"),
              url: "/site/siteinfo?targetTab=providerseq",
              icon: "fas fa-clipboard-list",
              pages: [config.accessRoles.provideroperator],
            },
            {
              name: this.$t("ui.game_name_exclude"),
              url: "/account/operator?targetTab=gamenameexclude",
              icon: "fas fa-ban",
              pages: [config.accessRoles.gamenameexclude],
            },
            {
              name: this.$t("ui.reward"),
              url: "/account/operator?targetTab=gamifyoperator",
              icon: "fas fa-gamepad",
              pages: [config.accessRoles.gamifyoperator],
            },
          ]
        },
        {
          name: this.$t("ui.member_management"),
          icon: "fas fa-users",
          pages: [config.accessRoles.memberlist, config.accessRoles.memberlabel, config.accessRoles.vip, config.accessRoles.bankmember],
          children: [
            {
              name: this.$t("ui.members"),
              url: "/account/operator?targetTab=memberlist",
              icon: "fa fa-users",
              pages: [config.accessRoles.memberlist],
            },
            {
              name: this.$t("ui.member_label"),
              url: "/account/operator?targetTab=memberlabel",
              icon: "fas fa-user-tag",
              pages: [config.accessRoles.memberlabel],
            },
            {
              name: this.$t("ui.vip"),
              url: "/account/operator?targetTab=vip",
              icon: "fas fa-crown",
              pages: [config.accessRoles.vip],
            },
            {
              name: this.$t("ui.bank_member"),
              url: "/account/operator?targetTab=bankmember",
              icon: "fas fa-landmark",
              pages: [config.accessRoles.bankmember],
            }
          ]
        },
        this.cpiEnable && cpiMenu,
        // {
        //   name: this.$t("ui.cpi"),
        //   icon: "fas fa-address-book",
        //   pages: [config.accessRoles.cpi],
        //   children: [
        //     {
        //       name: this.$t("ui.member_list"),
        //       url: "/cpi/cpi",
        //       icon: "fas fa-address-card",
        //       pages: [config.accessRoles.cpi],
        //     },
        //     {
        //       name: this.$t("ui.custom_list"),
        //       url: "/cpi/cpicustomlist",
        //       icon: "fas fa-address-book",
        //       pages: [config.accessRoles.cpi],
        //     },
        //     {
        //       name: this.$t("ui.phone_list"),
        //       url: "/cpi/cpioperatorphone",
        //       icon: "fas fa-phone",
        //       pages: [config.accessRoles.cpi],
        //     },
        //   ]
        // }, 
        {
          name: this.$t("ui.affiliate_management"),
          icon: "fas fa-user-tie",
          pages: [config.accessRoles.affiliatelist, config.accessRoles.approveaffiliate, config.accessRoles.ticketlistaffiliate, config.accessRoles.pendingticketaffiliate, config.accessRoles.adjustmentlogaffiliate],
          badge: this.totalBadge,
          children: [
            {
              name: this.$t("ui.affiliate_list"),
              url: "/affiliate/affiliateList",
              icon: "fas fa-user-tie",
              tab: "affiliate_list",
              pages: [config.accessRoles.affiliatelist],
            },
            {
              name: this.$t("ui.pending_application"),
              url: "/affiliate/approveAffiliate",
              icon: "fas fa-check-square",
              badge: this.affBadge,
              tab: "pending_application",
              pages: [config.accessRoles.approveaffiliate],
            },
            {
              name: this.$t("ui.withdrawal_list"),
              url: "/affiliate/ticketListAffiliate",
              icon: "fas fa-list-alt",
              tab: "withdrawal_list",
              pages: [config.accessRoles.ticketlistaffiliate],
            },
            {
              name: this.$t("ui.pending_review_withdrawal"),
              url: "/affiliate/pendingTicketAffiliate",
              icon: "fas fa-list-alt",
              // badge: this.tixBadge,
              pages: [config.accessRoles.pendingticketaffiliate],
            },
            {
              name: this.$t("ui.adjustment_log_affiliate"),
              url: "/affiliate/adjustmentLogAffiliate",
              icon: "fa fa-file",
              pages: [config.accessRoles.adjustmentlogaffiliate],
            },
            {
              name: this.$t("ui.audit_withdrawal"),
              url: "/affiliate/ticketListReviewAuditAffiliate",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlistreviewauditaffiliate],
            },
          ]
        },
        {
          name: this.$t("ui.free_credit_provider"),
          icon: "fas fa-user-alt",
          badge: this.totalFcBadge,
          pages: [config.accessRoles.ticketlistaffiliatefree, config.accessRoles.pendingticketaffiliatefree, config.accessRoles.ticketlistreviewauditaffiliatefree, 
                  config.accessRoles.ticketprocessedfree, config.accessRoles.adjustfreebalancelog],
          children: [
            {
              name: this.$t("ui.withdrawal_list"),
              url: "/freecreditprovider/ticketListAffiliateFree",
              icon: "fas fa-list-alt",
              tab: "withdrawal_list",
              pages: [config.accessRoles.ticketlistaffiliatefree],
            },
            {
              name: this.$t("ui.pending_review_withdrawal"),
              url: "/freecreditprovider/pendingTicketAffiliateFree",
              icon: "fas fa-list-alt",
              display_notif: this.displayFcNotif,
              // badge: this.tixBadge,
              pages: [config.accessRoles.pendingticketaffiliatefree],
            },
            {
              name: this.$t("ui.audit_withdrawal"),
              url: "/freecreditprovider/ticketListReviewAuditAffiliateFree",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlistreviewauditaffiliatefree],
            },
            {
              name: this.$t("ui.adjust_free_balance_log"),
              url: "/log/adjustFreeBalanceLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.adjustfreebalancelog],
            },
            {
              name: this.$t("ui.ticket_list_processed"),
              url: "/freecreditprovider/ticketProcessedFree",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketprocessedfree],
            },
          ]
        },
        {
          name: this.$t("ui.promotion_management"),
          icon: "fas fa-calendar-check",
          pages: [config.accessRoles.promotion, config.accessRoles.campaign, config.accessRoles.rescuefund],
          children: [
            {
              name: this.$t("ui.mbcampaign"),
              url: "/account/operator?targetTab=campaign",
              icon: "fas fa-calendar-check",
              pages: [config.accessRoles.campaign],
            },
            {
              name: this.$t("ui.rescue_fund"),
              url: "/account/operator?targetTab=rescuefund",
              icon: "fas fa-life-ring",
              pages: [config.accessRoles.rescuefund],
            },
            {
              name: this.$t("ui.promotion"),
              url: "/account/operator?targetTab=promotion&subTab=promotion",
              icon: "fas fa-gift",
              pages: [config.accessRoles.promotion],
            },
            {
              name: this.$t("ui.promotion_member"),
              url: "/account/operator?targetTab=promotion&subTab=promomember",
              icon: "fas fa-gift",
              pages: [config.accessRoles.promotion],
            },
            {
              name: this.$t("ui.promotion_signup"),
              url: "/account/operator?targetTab=promotion&subTab=promosignup",
              icon: "fas fa-gift",
              pages: [config.accessRoles.promotion],
            },
          ]
        },
        {
          name: this.$t("ui.ticket"),
          icon: "fas fa-list-alt",
          pages: [config.accessRoles.ticketlistop, config.accessRoles.pendingticket, config.accessRoles.ticketlistreviewaudit],
          children: [
            {
              name: this.$t("ui.ticket_list_member"),
              url: "/ticketoperator/ticketListOp",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlistop],
            },
            {
              name: this.$t("ui.pending_review_funds"),
              url: "/ticket/pendingTicket",
              icon: "fas fa-list-alt",
              // badge: this.supersedeBadge,
              pages: [config.accessRoles.pendingticket],
            },
            {
              name: this.$t("ui.daifu_list_auto_withdrawal"),
              url: "/ticket/ticketListAutoWithdrawal",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlistautowithdrawal],
            },
            {
              name: this.$t("ui.audit_list"),
              url: "/ticket/ticketListReviewAudit",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlistreviewaudit],
            },
          ]
        },
        {
          name: this.$t("ui.ticketvoucher"),
          icon: "fas fa-list-alt",
          pages: [config.accessRoles.ticketlistopvoucher, config.accessRoles.pendingticketvoucher],
          children: [
            {
              name: this.$t("ui.ticket_voucher_list_member"),
              url: "/ticketvoucher/ticketListOpVoucher",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlistopvoucher],
            },
            {
              name: this.$t("ui.pending_review_funds_voucher"),
              url: "/ticketvoucher/pendingTicketVoucher",
              icon: "fas fa-list-alt",
              // badge: this.supersedeBadge,
              pages: [config.accessRoles.pendingticketvoucher],
            }
          ]
        },
        {
          name: this.$t("ui.report"),
          icon: "fas fa-chart-line",
          pages: [config.accessRoles.dailysummaryoperator, config.accessRoles.dailyledger, config.accessRoles.providerwinlosecompany,
                  config.accessRoles.dailywinlosegame, config.accessRoles.providerwinloseoperator, config.accessRoles.providerwinloseoperatorpt,
                  config.accessRoles.onetimedepositor, config.accessRoles.currentmonthnondepositor, config.accessRoles.currentmonthnologin,
                  config.accessRoles.depositedmember, config.accessRoles.registeredmember, config.accessRoles.firstdeposit,
                  config.accessRoles.promotionsignupunused, config.accessRoles.promotionsignupongoing, config.accessRoles.promotionsignupwinlose, config.accessRoles.promotionsummary, config.accessRoles.promotionwithdrawalsummary, config.accessRoles.rebatesummary,
                  config.accessRoles.rebatemember, config.accessRoles.rescuefundsummary, config.accessRoles.dailysummarysms, config.accessRoles.dailysummarycompany,
                  config.accessRoles.totalplayedminigame, config.accessRoles.dailypnloperator, config.accessRoles.totalminigamecoinused,
                  config.accessRoles.totalminigamereward, config.accessRoles.voucherredeemed
          ],
          children: [
            {
              name: this.$t("ui.daily_winlose_game"),
              url: "/report/dailyWinLoseGame",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailywinlosegame]
            },
            {
              name: this.$t("ui.provider_winlose_company"),
              url: "/report/providerWinLoseCompany",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.providerwinlosecompany]
            },
            {
              name: this.$t("ui.provider_winlose_operator"),
              url: "/report/providerWinLoseOperator",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.providerwinloseoperator]
            },
            {
              name: this.$t("ui.provider_winlose_operator_pt"),
              url: "/report/providerWinLoseOperatorPt",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.providerwinloseoperatorpt]
            },
            {
              name: this.$t("ui.daily_pnl_operator"),
              url: "/report/dailyPnlOperator",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailypnloperator]
            },
            {
              name: this.$t("ui.daily_summary_company"),
              url: "/report/dailySummaryCompany",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailysummarycompany]
            },
            {
              name: this.$t("ui.daily_summary_operator"),
              url: "/report/dailySummaryOperator",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailysummaryoperator]
            },
            {
              name: this.$t("ui.daily_summary_sms"),
              url: "/report/dailySummarySMS",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailysummarysms]
            },
            {
              name: this.$t("ui.daily_ledger"),
              url: "/report/dailyLedger",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailyledger]
            },
            {
              name: this.$t("ui.one_time_depositor"),
              url: "/report/oneTimeDepositor",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.onetimedepositor]
            },
            {
              name: this.$t("ui.current_month_non_depositor"),
              url: "/report/currentMonthNonDepositor",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.currentmonthnondepositor]
            },
            {
              name: this.$t("ui.current_month_no_login"),
              url: "/report/currentMonthNoLogin",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.currentmonthnologin]
            },
            {
              name: this.$t("ui.deposited_member"),
              url: "/report/depositedMember",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.depositedmember]
            },
            {
              name: this.$t("ui.registered_member"),
              url: "/report/registeredMember",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.registeredmember]
            },
            {
              name: this.$t("ui.first_deposit"),
              url: "/report/firstDeposit",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.firstdeposit]
            },
            {
              name: this.$t("ui.promotion_signup_unused"),
              url: "/report/promotionSignupUnused",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionsignupunused]
            },
            {
              name: this.$t("ui.promotion_signup_ongoing"),
              url: "/report/promotionSignupOngoing",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionsignupongoing]
            },
            {
              name: this.$t("ui.promotion_signup_winlose"),
              url: "/report/promotionSignUpWinlose",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionsignupwinlose]
            },
            {
              name: this.$t("ui.promotion_summary"),
              url: "/report/promotionSummary",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionsummary]
            },
            {
              name: this.$t("ui.promotion_withdrawal_summary"),
              url: "/report/promotionWithdrawalSummary",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionwithdrawalsummary]
            },
            {
              name: this.$t("ui.rebate_summary"),
              url: "/report/rebateSummary",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.rebatesummary]
            },
            {
              name: this.$t("ui.rebate_member"),
              url: "/report/rebateMember",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.rebatemember]
            },
            {
              name: this.$t("ui.rescue_fund_summary"),
              url: "/report/rescueFundSummary",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.rescuefundsummary]
            },
            {
              name: this.$t("ui.total_played_mini_game"),
              url: "/report/totalPlayedMiniGame",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.totalplayedminigame],
            },
            {
              name: this.$t("ui.total_mini_game_token_used"),
              url: "/report/totalMiniGameCoinUsed",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.totalminigamecoinused],
            },
            {
              name: this.$t("ui.total_mini_game_reward"),
              url: "/report/totalMiniGameReward",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.totalminigamereward],
            },
            {
              name: this.$t("ui.voucher_redeemed"),
              url: "/report/voucherRedeemed",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.voucherredeemed],
            }
          ]
        },
        {
          name: this.$t("ui.log"),
          icon: "fas fa-search",
          pages: [config.accessRoles.gamenameexlog, config.accessRoles.adjustmentlog, config.accessRoles.bonuslog, config.accessRoles.memberloginlog,
                  config.accessRoles.resultchangeslog, config.accessRoles.viplog, config.accessRoles.membertokenlog,
                  config.accessRoles.memberlog, config.accessRoles.membersosclicklog, config.accessRoles.memberwalletvoucherlog,
                  config.accessRoles.freespinlog, config.accessRoles.membervoucherredeemedlog],
          children: [
            {
              name: this.$t("ui.game_name_exclude_log"),
              url: "/log/gamenameexlog",
              icon: "fa fa-search",
              pages: [config.accessRoles.gamenameexlog],
            },
            {
              name: this.$t("ui.adjustment_log"),
              url: "/log/adjustmentLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.adjustmentlog],
            },
            {
              name: this.$t("ui.bonus_log"),
              url: "/log/bonusLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.bonuslog],
            },
            {
              name: this.$t("ui.login_log"),
              url: "/log/memberLoginLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.memberloginlog],
            },
            {
              name: this.$t("ui.result_changes_log"),
              url: "/log/resultChangesLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.resultchangeslog],
            },
            {
              name: this.$t("ui.vip_log"),
              url: "/log/vipLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.viplog],
            },
            {
              name: this.$t("ui.token_log"),
              url: "/log/membertokenLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.membertokenlog],
            },
            {
              name: this.$t("ui.member_log"),
              url: "/log/memberLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.memberlog],
            },
            {
              name: this.$t("ui.member_sos_click_log"),
              url: "/log/memberSosClickLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.membersosclicklog],
            },
            {
              name: this.$t("ui.member_wallet_voucher_log"),
              url: "/log/memberWalletVoucherLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.memberwalletvoucherlog],
            },
            {
              name: this.$t("ui.member_voucher_redeemed_log"),
              url: "/log/memberVoucherRedeemedLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.membervoucherredeemedlog],
            },
            {
              name: this.$t("ui.freespin_log"),
              url: "/log/freeSpinLog",
              icon: "fa fa-search",
              pages: [config.accessRoles.freespinlog],
            }
          ]
        }
      ].filter(Boolean); // removes false/undefined entries;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    totalBadge() {
      // return { "text": this.affTotalRow + this.tixTotalRow, "variant": "danger" }
      return { "text": this.affTotalRow, "variant": "danger" }
    },
    tixBadge() {
      return { "text": this.tixTotalRow, "variant": "danger" }
    },
    affBadge() {
      return { "text": this.affTotalRow, "variant": "danger" }
    },
    totalFcBadge() {
      return { "text": this.fcTotalRow, "variant": "danger" }
    },
    displayFcNotif() {
      return this.fcTotalRow > 0 ? true : false
    },
    // supersedeBadge() {
    //   return { "text": this.supersedeCount, "variant": "danger" }
    // }, 
    showNotification() {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          if (this.$store.getters.accountAuthority[0].authority_option.includes('affiliate'))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        // if (this.$store.getters.accountId == config.superUser)
        //   return true;
        // else
        //   return false;
        return true
      }
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
    cpiEnable() {
      return config.cpiEnable == "1";
    }
  },
  created: function() {
    this.$options.refreshEnabled = true;
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if (this.$store.getters.accountId == config.superUser) {
        this.getInfo();
        // this.startCountDownRefresh();
      }
      this.startCountDownRefresh();
      this.startCountDownRefreshFc();
    }
  },
  destroyed: function() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    if(this.timerIdFc) {
      clearTimeout(this.timerIdFc)
    }
  },
  methods: {
    getInfo() {
      if (this.getAuthorityRole == 'SUB_PRI')
        this.getSubDetail();
    },
    getSubDetail() {
      let url = config.accountSubDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        login_id: this.$store.getters.loginId
      };

      this.$http.post(url, json).then(
        function(response) {
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.subDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    // getAffiliatePendingList() {
    //   let url = config.accountListPendingAffUrl();

    //   var json = {
    //     action_by: this.$store.getters.loginId,
    //     auth_token: this.$store.getters.sessionToken,
    //     sort_key: "account_id",
    //     sort_type: "asc",
    //     page_number: 1,
    //     page_size: this.getPageSize,
    //   };

    //   this.loading = true;
    //   this.$http.post(url, json).then(
    //     function(response) {
    //       this.loading = false;
    //       // Success
    //       try {
    //         if (response) {
    //           this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

    //           this.feedback.status = response.data.statusdesc;
    //           if (this.feedback.success == true) {
    //             this.affTotalRow = response.data.ds.list.length > 0 ? response.data.ds.list[0].totalrows : 0;
    //           } else {
    //             if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //           }
    //         }
    //       } catch (error) {
    //         this.feedback.success = false;
    //         this.feedback.status = errorTags.request.failed;
    //         this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //       }
    //     },
    //     function() {
    //       this.loading = false;
    //       // Error
    //       this.feedback.success = false;
    //       this.feedback.status = errorTags.request.failed;
    //       this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //     }
    //   );
    // },
    getAccountListPendingAffCount() {
      let url = config.accountListPendingAffCountUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.affTotalRow = response.data.dt.length > 0 ? response.data.dt[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTicketListPendingCountFree: function() {
      let url = config.ticketListPendingCountFreeUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.fcTotalRow = response.data.dt.length > 0 ? response.data.dt[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) {
                  this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    // getWithdrawalList() {
    //   let url = config.ticketListAffiliateUrl();

    //   var json = {
    //     action_by: this.$store.getters.loginId,
    //     auth_token: this.$store.getters.sessionToken,
    //     account_id: this.$store.getters.accountId,
    //     ticket_status: 0,
    //     start_date: this.$moment(new Date).format('YYYY-MM-DD'),
    //     end_date: this.$moment(new Date).format('YYYY-MM-DD'),
    //     sort_type: "desc",
    //     page_number: 1,
    //     page_size: this.getPageSize
    //   };

    //   this.loading = true;
    //   this.$http.post(url, json).then(
    //     function(response) {
    //       this.loading = false;
    //       // Success
    //       try {
    //         if (response) {
    //           this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

    //           this.feedback.status = response.data.statusdesc;
    //           if (this.feedback.success == true) {
    //             this.tixTotalRow = response.data.dt.length > 0 ? response.data.dt[0].totalrows : 0;
    //           } else {
    //             if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //           }
    //         }
    //       } catch (error) {
    //         this.feedback.success = false;
    //         this.feedback.status = errorTags.request.failed;
    //         this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //       }
    //     },
    //     function() {
    //       this.loading = false;
    //       // Error
    //       this.feedback.success = false;
    //       this.feedback.status = errorTags.request.failed;
    //       this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //     }
    //   );
    // },
    startCountDownRefresh: function() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      if (this.$options.refreshEnabled) {
        if (this.showNotification == true) {
          this.getAccountListPendingAffCount();
          // this.getAffiliatePendingList();
          // this.getWithdrawalList();
        }

        this.timerId = setTimeout(() => {
          this.startCountDownRefresh();
        }, this.refreshTime * 1000);
      }
    },
    startCountDownRefreshFc: function() {
      if (this.timerIdFc) {
        clearTimeout(this.timerIdFc);
      }
      if (this.$options.refreshEnabled) {
        if (this.showNotification == true) {
          this.getTicketListPendingCountFree();
        }

        this.timerIdFc = setTimeout(() => {
          this.startCountDownRefreshFc();
        }, this.refreshTimeFc * 1000);
      }
    },
    handleMinimized(e) {
      this.$store.dispatch("layout/setSidebarMinimized", e);
    }
  }
};
</script>

<style lang="scss" scoped>
.profile {
  height: 40px;
  // width: 50px;
}
</style>